import React from 'react'
import './modal.css'

const Modal = ({ children, handleClose }) => (
  <div className="modal-window">
    <div className="modal-message">
      <p>{children}</p>
      <button onClick={handleClose} className="modal-close">
        Close
      </button>
    </div>
  </div>
)

export default Modal
